import LineRoomUpgradeIcon from 'components/Luxkit/Icons/line/LineRoomUpgradeIcon'
import TextLink from 'components/Luxkit/TextLink'
import ModalContext from 'contexts/ModalContext'
import { withOfferPageAndReduxState } from 'contexts/OfferPage/withOfferPageState'
import withMountGuard from 'hocs/withMountGuard'
import { useAppSelector } from 'hooks/reduxHooks'
import { isHotelPackage } from 'lib/offer/offerTypes'
import LoyaltyTierCallOutBanner from 'loyalty/components/LoyaltyTierCallOutBanner'
import getLoyaltyTargetUpgradePackage from 'loyalty/lib/getLoyaltyTargetUpgradePackage'
import getIsLoyaltyEnabled from 'loyalty/selectors/getIsLoyaltyEnabled'
import getLoyaltyDisplayTier from 'loyalty/selectors/getLoyaltyDisplayTier'
import React, { useCallback, useContext } from 'react'
import { OfferPackageOptionView } from 'selectors/offerPage/offerPageSelectors'
import OfferPageLoyaltyRoomUpgradeCallOutBannerSwitch from './OfferPageLoyaltyRoomUpgradeCallOutBannerSwitch'
import AccommodationRoomDetailsModal from 'components/AccommodationKit/AccommodationRoomDetailsModal'

interface Props {
  packageView: OfferPackageOptionView;
  offer: App.Offer;
}

function OfferPageLoyaltyRoomUpgradeCallOutBanner({
  packageView,
  offer,
}: Props) {
  const { package: pkg } = packageView
  const tier = useAppSelector(getLoyaltyDisplayTier)
  const showModal = useContext(ModalContext)
  const targetUpgradePackage = getLoyaltyTargetUpgradePackage(offer, pkg)

  const showTargetUpgradeRoomDetails = useCallback(() => {
    if (!targetUpgradePackage || !isHotelPackage(targetUpgradePackage)) return
    showModal(<AccommodationRoomDetailsModal
      roomPackage={targetUpgradePackage}
    />)
  }, [showModal, targetUpgradePackage])

  if (!packageView.hasLoyaltyTargetUpgradeAvailable || !targetUpgradePackage) return null

  return <LoyaltyTierCallOutBanner
    tier={tier}
    end={<OfferPageLoyaltyRoomUpgradeCallOutBannerSwitch
      package={pkg}
    />}
    icon={<LineRoomUpgradeIcon />}
    subtitle={<TextLink onClick={showTargetUpgradeRoomDetails}>View upgraded room details</TextLink>}
  >
    Apply your free room upgrade to {targetUpgradePackage.name}
  </LoyaltyTierCallOutBanner>
}

export default withMountGuard(() => useAppSelector(getIsLoyaltyEnabled))(
  withOfferPageAndReduxState((state) => ({
    offer: state.offer,
  }), OfferPageLoyaltyRoomUpgradeCallOutBanner),
)
